import React, { useState } from "react"
import { useSelector } from "react-redux"
import { FormattedMessage } from "react-intl"
import classNames from "classnames"

import { BillingDetailsForm, Invoices, Subscription, Overview } from "./components"

const TABS = [
  {
    key: "overview",
    title: <FormattedMessage id="common.overviewTab.name" />,
  },
  {
    key: "invoices",
    title: <FormattedMessage id="common.invoicesTab.name" />,
  },
  {
    key: "billingInfo",
    title: <FormattedMessage id="common.billingInfoTab.name" />,
  },
];
const InvoicesSection = ({handleBillingClick}) => {
  const team = useSelector((state) => state.auth.team);
  
  if (!team.name || !team.registrationNumber) {
    return (
      <>
        <p className="section__title">
          <FormattedMessage id="common.invoices" />
        </p>
        <p>
          <FormattedMessage
            id="common.billingInformationRequired"
            values={{
              bold: (text) => <b>{text}</b>,
              link: (text) => <b><a className="link" onClick={handleBillingClick}>{text}</a></b>,
            }}
          />
        </p>
      </>
    )
  }

  return (<Invoices />);
}

const BillingInfo = () => {
  return (
    <>
      <p className="section__title">
        <FormattedMessage id="common.billingInformation" />
      </p>
      <BillingDetailsForm />
    </>
  )
}

const PlanAndBillingPage = () => {
  const authRole = useSelector((state) => state.auth.role)

  const [selectedTab, setSelectedTab] = useState(TABS[0].key);

  const handleBillingClick = () => {
    setSelectedTab(TABS[2].key);
  }

  if (authRole?.role !== "TeamOwner") {
    return (
      <div className="plan-and-billing-page">
        <p>You're not authorized.</p>
      </div>
    )
  }

  return (
    <div className="plan-and-billing-page">
      <Subscription />

      <div id="plan-and-billing-page-tabs">
        {TABS.map((tab) => (
          <div
            key={tab.key}
            className={classNames("btn btn--small btn--quinary", {
              "active": selectedTab === tab.key,
            })}
            onClick={() => setSelectedTab(tab.key)}
          >
            {tab.title}
          </div>
        ))}
      </div>
      
      <div className="section">
        {selectedTab === TABS[0].key && <Overview />}
        {selectedTab === TABS[1].key && <InvoicesSection handleBillingClick={handleBillingClick} />}
        {selectedTab === TABS[2].key && <BillingInfo />}
      </div>
    </div>
  )
}

export default PlanAndBillingPage
